import React from "react";
import EN from "../../locales/en";
import TextField from "./partials/TextField";

const YourContactDetails = () => (
  <div className="mt-8 border-t border-[#afb6b9]">
    <h2 className="text-[30px] font-bold text-primary mt-6">
      {EN.switch.your_contact_details.title}
    </h2>
    <div className="space-y-4">
      <TextField
        key="customerInfo.custEmail1"
        name="customerInfo.custEmail1"
        label={EN.switch.your_contact_details.email_label}
        type="email"
        placeholder={EN.switch.your_contact_details.email_placeholder}
      />
      <TextField
        key="customerInfo.confirmEmail"
        name="customerInfo.confirmEmail"
        label={EN.switch.your_contact_details.confirm_email_label}
        type="email"
        placeholder={EN.switch.your_contact_details.confirm_email_placeholder}
      />
      <TextField
        key="customerInfo.custLandline1"
        name="customerInfo.custLandline1"
        label={EN.switch.your_contact_details.phone_label}
        placeholder={EN.switch.your_contact_details.phone_placeholder}
      />
    </div>
  </div>
);

export default YourContactDetails;
